import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useState} from "react";
import {
    faArrowPointer, faArrowsToEye,
    faHand,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus
} from "@fortawesome/free-solid-svg-icons";
import '../styles/OverlayDiv.css';

const OverlayControl = ({ icon, onClick }) => {
    return <span className="control" onClick={onClick}><FontAwesomeIcon icon={icon}/></span>
}

const OverlayDiv = ({ showControls = true, ...props }) => {
    const [ mode, setMode ] = useState("NORMAL");

    const [ location, setLocation ] = useState({ x: 0, y: 0 });
    const [ scale, setScale ] = useState(1);

    const [ isPanning, setPanning ] = useState(false);
    const [ panningStarted, setPanningStarted ] = useState({});
    const [ panningStopped, setPanningStopped ] = useState({});
    const [ panningInitial, setPanningInitial ] = useState({});

    return (
        <div className={`OverlayDiv ${mode === "PAN" ? "pan" : ""}`} tabIndex={0}
             onMouseDown={e => {
                 if (mode !== "PAN") return;

                 setPanning(true);
                 setPanningStarted({ x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY });
                 setPanningStopped({ x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY });
                 setPanningInitial(location);
             }}
             onMouseMove={e => {
                 setPanningStopped({ x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY });

                 if (!isPanning) return;

                 const deltaX = (panningStopped.x - panningStarted.x) / scale;
                 const deltaY = (panningStopped.y - panningStarted.y) / scale;

                 setLocation({ x: panningInitial.x + deltaX, y: panningInitial.y + deltaY });
             }}
             onMouseOut={() => setPanning(false)}
             onMouseUp={() => setPanning(false)}
             onKeyUp={e => {
                 e.stopPropagation();
                 e.preventDefault();

                 if (e.key === 'h') {setLocation({ x: 0, y: 0 }); setScale(1);}
                 if (e.key === 'm') setMode("PAN");
                 if (e.key === 'p') setMode("NORMAL");
                 if (e.key === '-' || e.key === '_') setScale(Math.max(0.5, scale * 0.8));
                 if (e.key === '=' || e.key === '+') setScale(Math.min(20.0, scale / 0.8));
             }}>
            <div className="overlay-controls" style={{ display: showControls ? 'flex' : 'none' }}>
                <OverlayControl icon={faArrowPointer} onClick={() => setMode("NORMAL")}/>
                <OverlayControl icon={faHand} onClick={() => setMode("PAN")}/>
                <OverlayControl icon={faMagnifyingGlassPlus} onClick={() => setScale(Math.min(20.0, scale / 0.8))}/>
                <OverlayControl icon={faMagnifyingGlassMinus} onClick={() => setScale(Math.max(0.5, scale * 0.8))}/>
                <OverlayControl icon={faArrowsToEye} onClick={() => {setLocation({ x: 0, y: 0 }); setScale(1);}}/>
            </div>
            <div className="overlay-content"
                 style={{ transform: `scale(${scale}) translate(${location.x}px, ${location.y}px)` }}>{props.children}</div>
        </div>
    );
}

export default OverlayDiv;
